<template>
  <!-- 仅 ADMIN / ASSISTANT 渲染 -->
  <el-select
    v-if="canSeeSource"
    :value="value"
    placeholder="来源"
    clearable
    size="small"
    style="width:120px"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)">
    <el-option label="全部" value="" />
    <el-option label="🔵 自建" value="MANUAL" />
    <el-option label="🟠 社组" value="XJD" />
  </el-select>
</template>

<script>
export default {
  name: 'SourceFilter',
  props: {
    value: { type: String, default: '' }
  },
  computed: {
    canSeeSource() {
      try {
        const token = JSON.parse(localStorage.getItem('token') || '{}');
        const role = token.type || token.userType;
        return ['ADMIN', 'ASSISTANT'].includes(role);
      } catch (e) {
        return false;
      }
    }
  }
};
</script>
